import DeleteOutlineRoundedIcon from "@mui/icons-material/DeleteOutlineRounded";
import OpenInNewRoundedIcon from "@mui/icons-material/OpenInNewRounded";
import { IconButton, Tooltip, Chip } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { OssDataGridFrame } from "../common/OssDataGridFrame";
import { neutralChipSx } from "../common/ossChipStyles";

const documentTypeLabel = {
  PURCHASE_ORDER: "발주서",
  ORDER_FORM: "주문서",
  CHANGE_ORDER: "변경 근거",
  SPEC: "규격서",
  OTHER: "기타",
};

export const OssDocumentList = ({ rows = [], loading, onOpen, onDelete, height = 520 }) => (
  <OssDataGridFrame height={height}>
    <DataGrid
      disableRowSelectionOnClick
      loading={loading}
      rows={Array.isArray(rows) ? rows : []}
      getRowId={(row) => row?.document_id}
      rowHeight={54}
      columnHeaderHeight={44}
      columns={[
      { field: "order_no", headerName: "주문번호", flex: 0.9, headerAlign: "center", align: "center" },
      { field: "customer_name", headerName: "거래처", flex: 0.8, headerAlign: "center", align: "center" },
      { field: "item_name_snapshot", headerName: "품목", flex: 1, headerAlign: "center" },
      {
        field: "document_type",
        headerName: "문서 유형",
        flex: 0.8,
        headerAlign: "center",
        align: "center",
        renderCell: ({ value }) => <Chip size="small" label={documentTypeLabel[value] || value} variant="outlined" sx={neutralChipSx} />,
      },
      { field: "file_name", headerName: "파일명", flex: 1.4, headerAlign: "center" },
      { field: "version_no", headerName: "버전", flex: 0.45, headerAlign: "center", align: "center" },
      { field: "uploaded_at", headerName: "업로드 일시", flex: 0.9, headerAlign: "center", align: "center" },
      {
        field: "actions",
        headerName: "작업",
        flex: 1,
        headerAlign: "center",
        align: "center",
        sortable: false,
        renderCell: ({ row }) => (
          <>
            <Tooltip title="새 창에서 열기">
              <IconButton size="small" aria-label={row.file_name + " 열기"} onClick={() => onOpen(row)}><OpenInNewRoundedIcon fontSize="small" /></IconButton>
            </Tooltip>
            <Tooltip title="문서 삭제">
              <IconButton size="small" color="error" disabled={loading} aria-label={row.file_name + " 삭제"} onClick={() => onDelete(row)}><DeleteOutlineRoundedIcon fontSize="small" /></IconButton>
            </Tooltip>
          </>
        ),
      },
      ]}
      hideFooter={(Array.isArray(rows) ? rows.length : 0) <= 10}
      sx={{
        "& .MuiDataGrid-columnHeaderTitle": { fontSize: 12.5, fontWeight: 800, color: "#374151" },
        "& .MuiDataGrid-cell": { display: "flex", alignItems: "center", py: 0.6, color: "#374151" },
        "& .MuiDataGrid-row:hover": { bgcolor: "#fbfbfe" },
      }}
    />
  </OssDataGridFrame>
);
